if (!window.__quoteRequestInitialized) {
  window.__quoteRequestInitialized = true;

  const quotePhoneStage = new WeakMap();

  const consumeChileanPhoneChars = (input, chars) => {
    let stage = quotePhoneStage.get(input) || 'start';
    let local = input.dataset.quotePhoneLocal || '';

    for (const char of chars) {
      if (!/[0-9+]/.test(char) || local.length >= 8) continue;

      if (stage === 'start') {
        if (char === '+') {
          stage = 'plus';
        } else if (char === '5') {
          stage = 'five';
        } else if (char === '9') {
          stage = 'marker';
        } else {
          local += char;
          stage = 'marker';
        }
      } else if (stage === 'plus') {
        if (char === '5') {
          stage = 'five';
        } else if (char === '9') {
          stage = 'marker';
        } else {
          local += char;
          stage = 'marker';
        }
      } else if (stage === 'five') {
        if (char === '6') {
          stage = 'country';
        } else {
          local += char;
          stage = 'marker';
        }
      } else if (stage === 'country') {
        if (char === '9') {
          stage = 'marker';
        } else {
          local += char;
          stage = 'marker';
        }
      } else {
        local += char;
      }
    }

    quotePhoneStage.set(input, stage);
    input.dataset.quotePhoneLocal = local;
    return { stage, local };
  };

  const formatChileanPhone = (stage, local) => {
    if (stage === 'start' && local === '') return '';
    let formatted = '+56 9';
    if (local.length) formatted += ` ${local.slice(0, 4)}`;
    if (local.length > 4) formatted += ` ${local.slice(4, 8)}`;
    return formatted;
  };

  const renderChileanPhone = (input) => {
    const stage = quotePhoneStage.get(input) || 'start';
    const local = input.dataset.quotePhoneLocal || '';
    input.value = formatChileanPhone(stage, local);
    input.setSelectionRange(input.value.length, input.value.length);
  };

  const seedChileanPhone = (input) => {
    if (input.dataset.quotePhoneLocal !== undefined) return;
    const initialValue = input.value || '';
    input.dataset.quotePhoneLocal = '';
    quotePhoneStage.set(input, 'start');
    if (initialValue) {
      consumeChileanPhoneChars(input, initialValue);
      renderChileanPhone(input);
    }
  };

  const initChileanPhoneInputs = (root) => {
    root.querySelectorAll('[data-quote-phone-mask]').forEach((input) => seedChileanPhone(input));
  };

  document.addEventListener('beforeinput', (event) => {
    const input = event.target;
    if (!(input instanceof HTMLInputElement) || !('quotePhoneMask' in input.dataset)) return;

    seedChileanPhone(input);
    event.preventDefault();

    if (event.inputType === 'insertText' || event.inputType === 'insertFromPaste') {
      consumeChileanPhoneChars(input, event.data || '');
    } else if (event.inputType === 'deleteContentBackward' || event.inputType === 'deleteContentForward') {
      const local = input.dataset.quotePhoneLocal || '';
      const newLocal = local.slice(0, -1);
      input.dataset.quotePhoneLocal = newLocal;
      if (newLocal === '') quotePhoneStage.set(input, 'start');
    }

    renderChileanPhone(input);
  });

  const fillHiddenField = (modal, field, value) => {
    const input = modal.querySelector(`[data-quote-field="${field}"]`);
    if (input) input.value = value;
  };

  const updateContext = (modal, product, price) => {
    const textarea = modal.querySelector('[data-quote-context-field]');
    if (!textarea) return;

    const previousContext = textarea.dataset.quoteAutofill || '';
    const newContext = `Producto cotizado: ${product} | Precio: ${price}`;

    if (textarea.value.trim() === '' || textarea.value.trim() === previousContext.trim()) {
      textarea.value = newContext;
    }

    textarea.dataset.quoteAutofill = newContext;
  };

  const populateSharedModal = (modal, trigger) => {
    const product = trigger.dataset.quoteProduct || '';
    const price = trigger.dataset.quotePrice || '';
    const url = trigger.dataset.quoteUrl || '';

    fillHiddenField(modal, 'producto', product);
    fillHiddenField(modal, 'precio', price);
    fillHiddenField(modal, 'url', url);

    const subtitleProduct = modal.querySelector('[data-quote-subtitle-product]');
    if (subtitleProduct) subtitleProduct.textContent = product;

    updateContext(modal, product, price);
  };

  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-quote-trigger]');
    if (trigger) {
      const targetSelector = trigger.getAttribute('data-quote-target');
      const modal = targetSelector ? document.querySelector(targetSelector) : trigger.closest('.quote-modal');
      if (!modal || typeof modal.show !== 'function') return;

      if (modal.dataset.quoteMode === 'shared') populateSharedModal(modal, trigger);
      modal.show(trigger);
      return;
    }

    const closeButton = event.target.closest('[data-quote-close]');
    if (closeButton) {
      const modal = closeButton.closest('.quote-modal');
      if (modal && typeof modal.hide === 'function') modal.hide();
    }
  });

  const QUOTE_SUBMIT_STORAGE_KEY = 'quoteRequestSubmittedFormId';

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !('quoteForm' in form.dataset)) return;

    try {
      sessionStorage.setItem(QUOTE_SUBMIT_STORAGE_KEY, form.id);
    } catch (error) {
      /* sessionStorage unavailable (private mode, etc.) — falls back to default Liquid state */
    }

    const submitButton = document.querySelector(`.quote-modal__submit[form="${form.id}"]`);
    if (!submitButton) return;

    submitButton.classList.add('loading');
    submitButton.setAttribute('aria-disabled', 'true');
    submitButton.querySelector('.loading__spinner')?.classList.remove('hidden');
  });

  const resetQuoteModalToFormPanel = (modal) => {
    const formPanel = modal.querySelector('.quote-modal__panel--form');
    const successPanel = modal.querySelector('.quote-modal__panel--success');
    if (formPanel) formPanel.hidden = false;
    if (successPanel) successPanel.hidden = true;
    modal.removeAttribute('data-auto-open');
  };

  const reconcileQuoteModalsAfterSubmit = () => {
    const autoOpenModals = document.querySelectorAll('.quote-modal[data-auto-open="true"]');
    if (autoOpenModals.length < 2) return;

    let submittedFormId = null;
    try {
      submittedFormId = sessionStorage.getItem(QUOTE_SUBMIT_STORAGE_KEY);
    } catch (error) {
      submittedFormId = null;
    }

    if (!submittedFormId) return;

    autoOpenModals.forEach((modal) => {
      if (modal.dataset.quoteFormId !== submittedFormId) resetQuoteModalToFormPanel(modal);
    });
  };

  const protectQuoteForms = (attemptsLeft = 20) => {
    const captchaProtect = window.Shopify && window.Shopify.captcha && window.Shopify.captcha.protect;

    if (typeof captchaProtect !== 'function') {
      if (attemptsLeft > 0) setTimeout(() => protectQuoteForms(attemptsLeft - 1), 250);
      return;
    }

    document.querySelectorAll('form[data-quote-form]:not([data-quote-protected])').forEach((form) => {
      captchaProtect(form);
      form.setAttribute('data-quote-protected', 'true');
    });
  };

  const ensureQuoteModalsInBody = () => {
    document.querySelectorAll('.quote-modal').forEach((modal) => {
      if (modal.parentElement !== document.body) document.body.appendChild(modal);
    });
  };

  const initQuoteRequest = () => {
    ensureQuoteModalsInBody();
    initChileanPhoneInputs(document);
    protectQuoteForms();
    reconcileQuoteModalsAfterSubmit();

    try {
      sessionStorage.removeItem(QUOTE_SUBMIT_STORAGE_KEY);
    } catch (error) {
      /* sessionStorage unavailable — nothing to clear */
    }

    const autoOpenModal = document.querySelector('.quote-modal[data-auto-open="true"]');
    if (autoOpenModal && typeof autoOpenModal.show === 'function') autoOpenModal.show();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initQuoteRequest);
  } else {
    initQuoteRequest();
  }
}
